module.exports = __webpack_public_path__ + "img/header-weddingRingsExclusive@2x.745e311.jpg";